import { selectEntityStatus } from "../ui/ui.selectors";
import { SINGLE_STYLIZATION } from "./single-stylization.reducer";

export const selectSingleStylization = (state) => state[SINGLE_STYLIZATION];
export const selectSingleStylizationStatus = (state) =>
    selectEntityStatus(state, SINGLE_STYLIZATION);
